import styled from 'styled-components';

export const ErrorTitle = styled.p`
  margin-bottom: 8px;
  word-break: break-all;
`;

export const ErrorContainer = styled.ul`
  margin-bottom: 0;
  margin-left: 24px;
  padding: 0;
  font-size: 14px;
`;
